/**
 * Created by shubham on 11/4/18.
 */

import {PartnersPage} from "./partners-page";

/**
 * An array of data with an associated page object used for paging
 */
export class PartnersPageData<T> {
    data = new Array<T>();
    page = new PartnersPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/partners-dashboard/partners-datatable/partners-page-data.ts